var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-watch"},[_c('iframe',{staticClass:"video-watch__iframe",attrs:{"src":_vm.video.player,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }